import { Settings } from 'luxon';

export const IMAGE_HOST = 'https://kraftlund.imgix.net';

Settings.defaultLocale = 'en-SE';
